var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8999 35.5001C63.8999 43.0322 60.9077 50.2558 55.5817 55.5819C50.2557 60.9079 43.0321 63.9 35.4999 63.9C27.9678 63.9 20.7442 60.9079 15.4181 55.5819C10.0921 50.2558 7.09998 43.0322 7.09998 35.5001C7.09998 27.9679 10.0921 20.7443 15.4181 15.4183C20.7442 10.0923 27.9678 7.10014 35.4999 7.10014C38.1979 7.10014 40.8249 7.49064 43.3099 8.20064L48.8834 2.62715C44.6387 0.879014 40.0905 -0.0137259 35.4999 0.00015952C30.838 0.00015952 26.2217 0.918392 21.9147 2.70243C17.6076 4.48647 13.6942 7.10137 10.3977 10.3978C3.74016 17.0554 0 26.0849 0 35.5001C0 44.9152 3.74016 53.9448 10.3977 60.6023C13.6942 63.8988 17.6076 66.5137 21.9147 68.2977C26.2217 70.0818 30.838 71 35.4999 71C44.9151 71 53.9446 67.2598 60.6022 60.6023C67.2597 53.9448 70.9998 44.9152 70.9998 35.5001M20.9805 28.6841L15.975 33.7251L31.9499 49.7L67.4499 14.2001L62.4444 9.15914L31.9499 39.6536L20.9805 28.6841Z",
    fill: "#FFC700"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.9b4241de4910099370cff9ffdc654486.svg";
export { ForwardRef as ReactComponent };